var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DateTime } from 'luxon';
// Generate Date object with value Invalid Date
export const invalidDate = new Date('');
export const isInvalidDate = (d) => {
    if (typeof d === 'undefined')
        return false;
    return d instanceof Date && isNaN(d);
};
export const isValidDate = (date) => {
    if (date instanceof Date)
        return !isInvalidDate(date);
    return false;
};
const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const isBoolean = (value) => typeof value === 'boolean';
export const toDateObj = (_a) => {
    var { date, tz = defaultTimezone, isValid, invalidReason } = _a, rest = __rest(_a, ["date", "tz", "isValid", "invalidReason"]);
    const dateTime = toDateTime(date, tz);
    const valid = isBoolean(isValid) ? isValid : dateTime === null || dateTime === void 0 ? void 0 : dateTime.isValid;
    const reason = invalidReason;
    const result = Object.assign({ dateTime, timezone: tz, isValid: valid, invalidReason: reason }, rest);
    result.toISO = () => result.dateTime ? result.dateTime.toISO() : undefined;
    result.toJSDate = () => result.dateTime ? result.dateTime.toJSDate() : undefined;
    result.isEqualDate = (other) => {
        const dt1 = result.dateTime;
        const dt2 = other.dateTime;
        if ((!dt1 && !!dt2) || (!!dt1 && !dt2))
            return false; // One is valid, other not
        if (typeof dt1 === 'undefined' && typeof dt2 === 'undefined')
            return true; // Both undefined
        if (!dt1.isValid && !dt2.isValid)
            return true; // Both invalid
        return +dt1 === +dt2; // Compare millis
    };
    result.isEqual = (other) => result.isValid === other.isValid &&
        result.timezone === other.timezone &&
        result.invalidReason === other.invalidReason &&
        result.isEqualDate(other); // Equal dates
    return result;
};
export const toDateTime = (value, tz) => {
    var _a, _b;
    if (!value)
        return undefined;
    if (value instanceof DateTime)
        return value.setZone(tz);
    const timezone = tz || defaultTimezone;
    return value instanceof Date
        ? (_a = DateTime.fromJSDate(value)) === null || _a === void 0 ? void 0 : _a.setZone(timezone) // Parse Date
        : (_b = DateTime.fromISO(value)) === null || _b === void 0 ? void 0 : _b.setZone(timezone); // Parse String
};
export const toFormat = (date, format = 'LL/dd/yyyy') => {
    if (date instanceof Date)
        return DateTime.fromJSDate(date).toFormat(format);
    if (date instanceof DateTime)
        return date.toFormat(format);
    return date;
};
/*
 * Shifts date to timezone, so that date.toString()
 * to have same digits as corresponding date in timezone.
 */
export const toTimeZone = (date, tz, opts) => {
    const dateTime = (opts === null || opts === void 0 ? void 0 : opts.startOfDay)
        ? toDateTime(date, tz).startOf('day')
        : toDateTime(date, tz);
    return (dateTime === null || dateTime === void 0 ? void 0 : dateTime.isValid)
        ? new Date(dateTime.toISO({ includeOffset: false })) // Main routine
        : undefined;
};
// Inverse function for toTimeZone
export const fromTimeZone = (date, tz) => {
    var _a, _b;
    const unzoned = (_a = DateTime.fromJSDate(date)) === null || _a === void 0 ? void 0 : _a.toISO({ includeOffset: false });
    return (_b = DateTime.fromISO(unzoned, { zone: tz })) === null || _b === void 0 ? void 0 : _b.toJSDate();
};
export const compareObj = (value) => {
    if (value instanceof Date) {
        if (isInvalidDate(value))
            return 'Invalid Date';
        return value.getTime();
    }
    if (typeof value === 'undefined')
        return 'undefined';
    return value;
};
//# sourceMappingURL=utils.js.map